import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ContentCustomTags from "../models/ContentCustomTags";
import ManagerBase from "./ManagerBase";

class ContentCustomTagsManager extends ManagerBase {
	constructor () {
		super("contentCustomTagsManager");

		this.localClassReference = ContentCustomTags;
		this.remoteClassName = "content-custom-tags";
	}

	getByContentGuid (guid) {
		const rd = NousCore.api.createRequest({item: { guid } });
		const requestedAction = "get-by-content-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						return {
							data: Shark.getInstanceList(this.localClassReference, data.items) || [],
							requestedAction,
							status: "ok"
						};
					}
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}
}

const contentCustomTagsManager = new ContentCustomTagsManager();

Shark.registerController(contentCustomTagsManager);

export default contentCustomTagsManager;
